'use es6';

import modalStyleContent from 'raw-loader!cookie-banner/css/cookies-by-category.scss';
import Consent from 'cookie-banner/models/Consent';
import { ACCEPT_ALL_BUTTON_ID, ADVERTISEMENT_CATEGORY_ID, ADVERTISEMENT_TOGGLE_ID, ANALYTICS_CATEGORY_ID, ANALYTICS_TOGGLE_ID, CLOSE_BUTTON_ID, FUNCTIONALITY_CATEGORY_ID, FUNCTIONALITY_TOGGLE_ID, INTRODUCTION_ID, MODAL_ID, NECESSARY_CATEGORY_ID, SAVE_SETTINGS_BUTTON_ID, getModalHtml } from './modalHtml';
import { addClass, removeClass } from 'cookie-banner/utils/hspbUtils';
import { addEventListener, createHtmlElement } from 'cookie-banner/utils/hspbUtils';
import { CATEGORY_PREFERENCES_COOKIE, CATEGORY_PREFERENCES_COOKIE_EXPIRATION } from 'cookie-banner/constants/trackingCookies';
import { logDebug } from 'cookie-banner/utils/hspbUtils';
const KEYBOARD_KEYS = {
  DELETE: 46,
  DOWN: 40,
  END: 35,
  ENTER: 13,
  ESC: 27,
  HOME: 36,
  LEFT: 37,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38
};
const KEYBOARD_DIRECTION = {
  [KEYBOARD_KEYS.LEFT]: -1,
  [KEYBOARD_KEYS.UP]: -1,
  [KEYBOARD_KEYS.DOWN]: 1,
  [KEYBOARD_KEYS.RIGHT]: 1
};
const hideClassName = 'hs-hidden';
function focusOnModalIntro(doc) {
  const aboutCookies = doc.getElementById(INTRODUCTION_ID);
  aboutCookies.click();
  aboutCookies.focus();
}
function hideModal(doc) {
  const modal = doc.getElementById(MODAL_ID);
  addClass(modal, hideClassName);
}
function showModal(doc) {
  const modal = doc.getElementById(MODAL_ID);
  removeClass(modal, hideClassName);
  focusOnModalIntro(doc);
}
function isModalVisible(doc) {
  const modal = doc.getElementById(MODAL_ID);
  return modal.className.indexOf(hideClassName, 0) === -1;
}
function handleAllSelected(stagedCategories, doc) {
  const acceptAll = doc.getElementById(ACCEPT_ALL_BUTTON_ID);
  const allToggledOn = stagedCategories.stagedAnalytics && stagedCategories.stagedAdvertisement && stagedCategories.stagedFunctionality;
  if (allToggledOn) {
    addClass(acceptAll, hideClassName);
  } else {
    removeClass(acceptAll, hideClassName);
  }
}
function addAriaLiveDescription(stagedCategories, doc) {
  const ariaLive = doc.getElementById('hs-a11y-live');
  ariaLive.textContent = `Here is your current cookie selection,
  necessary cookies: always allowed,
  analytics cookies: ${stagedCategories.stagedAnalytics ? 'allowed' : 'not allowed'},
  advertisement cookies: ${stagedCategories.stagedAdvertisement ? 'allowed' : 'not allowed'},
  functionality cookies: ${stagedCategories.stagedFunctionality ? 'allowed' : 'not allowed'}`;
}
function writeConsentCookies(banner) {
  const consent = banner.privacyConsent;
  if (banner.privacySettings.testing) {
    logDebug('Testing mode - the following cookies were not written');
    logDebug(`cookie: "${CATEGORY_PREFERENCES_COOKIE}" value: "${consent.toCookieString()}"`);
    return;
  }
  banner.cookie.set(CATEGORY_PREFERENCES_COOKIE, consent.toCookieString(), {
    daysToExpire: CATEGORY_PREFERENCES_COOKIE_EXPIRATION,
    path: '/'
  });
  if (consent.categories.analytics) {
    banner.trackAction('trackApproveCookieConsent');
  } else {
    banner.trackAction('trackDeclineCookieConsent');
  }
}
function addSaveSettingsLintener(doc, banner, stagedCategories, hideBannerFn) {
  const saveSettingsButton = doc.getElementById(SAVE_SETTINGS_BUTTON_ID);
  addEventListener(saveSettingsButton, 'click', evt => {
    evt.preventDefault();
    hideModal(doc);
    hideBannerFn();
    const analytics = stagedCategories.stagedAnalytics;
    const advertisement = stagedCategories.stagedAdvertisement;
    const functionality = stagedCategories.stagedFunctionality;

    // TODO: Remove this when we deprecate the allowed field
    const allowed = analytics && advertisement && functionality;
    banner.setPrivacyConsent(new Consent(allowed, {
      necessary: true,
      analytics,
      advertisement,
      functionality
    }), {
      reporting: true
    });
    writeConsentCookies(banner);
  });
}
function addAcceptAllListener(doc, banner, hideBannerFn) {
  const acceptAllButton = doc.getElementById(ACCEPT_ALL_BUTTON_ID);
  addEventListener(acceptAllButton, 'click', evt => {
    evt.preventDefault();
    hideModal(doc);
    hideBannerFn();
    banner.setPrivacyConsent(true, {
      reporting: true
    });
    writeConsentCookies(banner);
  });

  //a11y
  addEventListener(acceptAllButton, 'keydown', evt => {
    if (evt.keyCode === KEYBOARD_KEYS.TAB) {
      doc.getElementById(INTRODUCTION_ID).focus();
      evt.preventDefault();
    }
  });
}
function addCategoryListeners(banner, stagedCategories, doc) {
  const categoryLabels = doc.querySelectorAll('.hs-category-label');
  const categoryDescriptions = doc.querySelectorAll('.hs-category-description');
  const labelIdByCategoryDescription = {};
  categoryDescriptions.forEach(element => {
    const labelId = element.id.replace('-description', '');
    labelIdByCategoryDescription[labelId] = element;
  });
  const labelIds = [];
  for (let i = 0; i < categoryLabels.length; i++) {
    labelIds.push(categoryLabels[i].id);
  }
  let previousActiveLabel = doc.getElementById(INTRODUCTION_ID);
  let previousActiveDescription = doc.getElementById(`${INTRODUCTION_ID}-description`);
  const activeClass = 'hs-active';
  function toggleCategoryDisplay(evt) {
    const label = evt.currentTarget;
    if (label.classList.contains(activeClass)) {
      return;
    }
    removeClass(previousActiveLabel, activeClass);
    previousActiveLabel.parentElement.setAttribute('aria-selected', false);
    addClass(label, activeClass);
    label.parentElement.setAttribute('aria-selected', true);
    addClass(previousActiveDescription, hideClassName);
    previousActiveDescription.setAttribute('aria-hidden', true);
    const description = labelIdByCategoryDescription[label.id];
    removeClass(description, hideClassName);
    description.setAttribute('aria-hidden', false);
    previousActiveLabel = label;
    previousActiveDescription = description;
    label.focus();
  }
  function toggleCategoryByDirection(index, numLabels, direction) {
    if (direction === 1 && index === numLabels - 1) {
      doc.getElementById(labelIds[0]).click();
    } else if (direction === -1 && index === 0) {
      doc.getElementById(labelIds[numLabels - 1]).click();
    } else {
      doc.getElementById(labelIds[index + direction]).click();
    }
  }
  function handleKeyPress(evt) {
    const key = evt.keyCode;
    const id = evt.currentTarget.id;
    const index = labelIds.indexOf(id);
    const numLabels = labelIds.length;
    switch (key) {
      case KEYBOARD_KEYS.END:
        evt.preventDefault();
        categoryLabels[numLabels - 1].click();
        break;
      case KEYBOARD_KEYS.HOME:
        evt.preventDefault();
        categoryLabels[0].click();
        break;
      case KEYBOARD_KEYS.ENTER:
      case KEYBOARD_KEYS.SPACE:
        evt.currentTarget.click();
        break;
      case KEYBOARD_KEYS.LEFT:
      case KEYBOARD_KEYS.RIGHT:
        toggleCategoryByDirection(index, numLabels, KEYBOARD_DIRECTION[key]);
        break;
      case KEYBOARD_KEYS.UP:
      case KEYBOARD_KEYS.DOWN:
        evt.preventDefault();
        toggleCategoryByDirection(index, numLabels, KEYBOARD_DIRECTION[key]);
        break;
      default:
        break;
    }
  }
  categoryLabels.forEach(label => {
    addEventListener(label, 'click', toggleCategoryDisplay);
    //a11y
    addEventListener(label, 'keydown', handleKeyPress);
  });

  // we do not want minification to compress this function name
  // it is used in the html of the modal
  banner.context.getWindow().handleHsCategoryToggle = categoryId => {
    const checkmark = doc.getElementById(`${categoryId}-checked`);
    const crossmark = doc.getElementById(`${categoryId}-unchecked`);
    return function handle(element) {
      if (element.checked) {
        removeClass(checkmark, hideClassName);
        addClass(crossmark, hideClassName);
      } else {
        removeClass(crossmark, hideClassName);
        addClass(checkmark, hideClassName);
      }
      switch (categoryId) {
        case ANALYTICS_CATEGORY_ID:
          stagedCategories.stagedAnalytics = element.checked;
          break;
        case ADVERTISEMENT_CATEGORY_ID:
          stagedCategories.stagedAdvertisement = element.checked;
          break;
        case FUNCTIONALITY_CATEGORY_ID:
          stagedCategories.stagedFunctionality = element.checked;
          break;
        case NECESSARY_CATEGORY_ID:
          break;
        default:
          return;
      }
      handleAllSelected(stagedCategories, doc);

      //a11y
      addAriaLiveDescription(stagedCategories, doc);
    };
  };
}
function addEscapeKeyListener(doc) {
  addEventListener(doc, 'keydown', evt => {
    if (evt.keyCode === KEYBOARD_KEYS.ESC && isModalVisible(doc)) {
      hideModal(doc);
    }
  });
}
function addCategoryToggleListeners(banner, doc) {
  const analyticsToggle = doc.getElementById(ANALYTICS_TOGGLE_ID);
  const advertisementToggle = doc.getElementById(ADVERTISEMENT_TOGGLE_ID);
  const functionalityToggle = doc.getElementById(FUNCTIONALITY_TOGGLE_ID);
  addEventListener(analyticsToggle, 'click', () => {
    banner.context.getWindow().handleHsCategoryToggle(ANALYTICS_CATEGORY_ID)(analyticsToggle);
  });
  addEventListener(advertisementToggle, 'click', () => {
    banner.context.getWindow().handleHsCategoryToggle(ADVERTISEMENT_CATEGORY_ID)(advertisementToggle);
  });
  addEventListener(functionalityToggle, 'click', () => {
    banner.context.getWindow().handleHsCategoryToggle(FUNCTIONALITY_CATEGORY_ID)(functionalityToggle);
  });
}
function addListeners(doc, banner, stagedCategories, hideBannerFn) {
  const closeButton = doc.getElementById(CLOSE_BUTTON_ID);
  addEventListener(closeButton, 'click', () => hideModal(doc));
  addCategoryListeners(banner, stagedCategories, doc);
  addSaveSettingsLintener(doc, banner, stagedCategories, hideBannerFn);
  addAcceptAllListener(doc, banner, hideBannerFn);
  addCategoryToggleListeners(banner, doc);

  //a11y
  addEscapeKeyListener(doc);
}
function toggleCategoryIfNecessary(categoryConsent, toggleId, categoryId, doc) {
  const toggle = doc.getElementById(toggleId);
  const checkmark = doc.getElementById(`${categoryId}-checked`);
  const crossmark = doc.getElementById(`${categoryId}-unchecked`);
  if (categoryConsent === toggle.checked) {
    return;
  }
  toggle.checked = !toggle.checked;
  if (toggle.checked) {
    removeClass(checkmark, hideClassName);
    addClass(crossmark, hideClassName);
  } else {
    removeClass(crossmark, hideClassName);
    addClass(checkmark, hideClassName);
  }
}
function toggleToMatchConsent(consent, doc) {
  toggleCategoryIfNecessary(consent.categories.analytics, ANALYTICS_TOGGLE_ID, ANALYTICS_CATEGORY_ID, doc);
  toggleCategoryIfNecessary(consent.categories.advertisement, ADVERTISEMENT_TOGGLE_ID, ADVERTISEMENT_CATEGORY_ID, doc);
  toggleCategoryIfNecessary(consent.categories.functionality, FUNCTIONALITY_TOGGLE_ID, FUNCTIONALITY_CATEGORY_ID, doc);
}
export default class Template {
  constructor(banner) {
    this.banner = banner;
    this.stagedCategories = {
      stagedAnalytics: false,
      stagedAdvertisement: false,
      stagedFunctionality: false
    };
    if (!banner.privacyConsent) {
      const initialConsent = Consent.buildInitialConsent();
      this.setStagedCategories(initialConsent);
    } else {
      this.setStagedCategories(banner.privacyConsent);
    }
  }
  hasRendered() {
    const {
      context
    } = this.banner;
    const doc = context.getDocument();
    return doc.getElementById(MODAL_ID) !== null;
  }
  setStagedCategories(consent) {
    if (!consent || !consent.categories) {
      return;
    }
    this.stagedCategories.stagedAnalytics = consent.categories.analytics;
    this.stagedCategories.stagedAdvertisement = consent.categories.advertisement;
    this.stagedCategories.stagedFunctionality = consent.categories.functionality;
  }
  displayModal() {
    const {
      context
    } = this.banner;
    const doc = context.getDocument();
    const consentToMatch = this.banner.privacyConsent ? this.banner.privacyConsent : Consent.buildInitialConsent();
    this.setStagedCategories(consentToMatch);
    handleAllSelected(this.stagedCategories, doc);
    toggleToMatchConsent(consentToMatch, doc);
    showModal(doc);
  }
  render(bannerDOMParent, privacySettings, hideBannerFn) {
    const {
      context
    } = this.banner;
    const {
      accentColor,
      cookiesByCategory
    } = privacySettings;

    // TODO: Remove some time in the future. IE does not have NodeList.forEach
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }
    const doc = context.getDocument();
    if (this.hasRendered()) {
      return;
    }
    const consentOnRender = this.banner.privacyConsent ? this.banner.privacyConsent : Consent.buildInitialConsent();
    this.setStagedCategories(consentOnRender);
    const modalHtml = getModalHtml(cookiesByCategory, consentOnRender);
    const styleContent = accentColor ? modalStyleContent.replace(/#425b76/g, accentColor) : modalStyleContent;
    const styleTag = doc.createElement('style');
    styleTag.setAttribute('type', 'text/css');
    if (styleTag.styleSheet) {
      styleTag.styleSheet.cssText = styleContent;
    } else {
      const textTag = doc.createTextNode(styleContent);
      styleTag.appendChild(textTag);
    }
    const firstBodyElement = bannerDOMParent.childNodes[0];
    bannerDOMParent.insertBefore(styleTag, firstBodyElement);
    bannerDOMParent.insertBefore(createHtmlElement(modalHtml), firstBodyElement);
    const modal = doc.getElementById(MODAL_ID);
    if (!modal) {
      return;
    }
    focusOnModalIntro(doc);
    addListeners(doc, this.banner, this.stagedCategories, hideBannerFn);
    handleAllSelected(this.stagedCategories, doc);
  }
}